import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { flagChecker } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SiteLocationService } from 'src/app/services/site-location/site-location.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from '../../menu/navigator';
import { MobileDataService } from 'src/app/services/mobile-data/mobile-data.service';

@Component({
  selector: 'app-rglogo',
  templateUrl: './rglogo.component.html',
  styleUrls: ['./rglogo.component.scss'],
})
export class RglogoComponent implements OnInit {

  @Input() isClickable: boolean = true;
  @Input() environmentName?: string;

  public rgLink: string;
  public showLogo: boolean = true;
  public rgLogoSrc: string;

  constructor(
    public config: ConfigService,
    public eventsService: EventsService,
    public navigator: Navigator,
    public utils: UtilsService,
    public platform: Platform,
    public siteLocationService: SiteLocationService,
    public mobileData: MobileDataService
  ) {
  }

  ngOnInit(): void {
    this.showLogo = !flagChecker(this.config.getConfig().FEATURE_RG_LOGO_LINK); //0 for show 1 for hide in BO
    this.environmentName = this.environmentName || this.config.getState();
    const statesRgLogoMap = this.siteLocationService.statesRgLogoMap;
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.environmentName = this.config.getState();
        this.rgLogoSrc = this.utils.getCDNAsset(statesRgLogoMap[this.environmentName]);
        this.mobileData.setRgLogoSrc(this.rgLogoSrc);
      })
    });

    this.rgLogoSrc = this.utils.getCDNAsset(statesRgLogoMap[this.environmentName]);
    this.mobileData.setRgLogoSrc(this.rgLogoSrc);
  }

  onRGLogo() {
    if (this.isClickable == false) return;
    return this.navigator.navigateTo("PlayerProtectionComponent", '', { path: 'rglogo' });
  }

}
